"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptimizedImageSource = getOptimizedImageSource;
const is_object_1 = __importDefault(require("./is-object"));
const OPTIMIZE_PATH = "/cdn-cgi/image/";
const DEFAULT_QUALITY = 75; // recommended values are 50-100
const DEFAULT_DPR = 2; // device pixel ratio - 2 targets standard "retina"
function optionsToString(options) {
    return Object.entries(options)
        .filter((entry) => entry[1] !== undefined)
        .map(([key, value]) => key + "=" + encodeURIComponent(value))
        .join(",");
}
function getOptimizedImageUrl(originalUrl, options) {
    return originalUrl.replace(new RegExp(`(https://(cdn|cdn2|admin).(treefortsystems|treefortstaging).com)(${OPTIMIZE_PATH}[^/]*)?`), "$1" +
        OPTIMIZE_PATH +
        optionsToString({
            fit: "scale-down", // never scale an image larger than the source
            onerror: "redirect", // redirect to the original image if we can't resize
            metadata: "none", // drop all metadata
            format: "auto", // use webp if the client supports it
            dpr: options.dpr || DEFAULT_DPR,
            quality: options.quality || DEFAULT_QUALITY,
            width: options.width,
            height: options.height,
            background: options.backgroundColor,
        }));
}
/**
 * Get an image source that will point to an optimized version of the image.
 * Only works with image sources that point to our CDN - for all other images
 * the original source will be returned.
 *
 * If the width and/or height that the image will be displayed at is known then
 * provide those values via options. This will fetch an image that is no bigger
 * than necessary. The width and height should be specified as
 * device-independent pixels (e.g. the CSS width/height properties used to
 * display the image). To scale the image up/down based on pixel density, use
 * the "dpr" (device pixel ratio) option (defaults to 2). Do not provide highly
 * dynamic values here (e.g. values that vary infinitely based on the viewport
 * dimensions) or performance will suffer due to excessive cache misses and
 * we'll get charged more by Cloudflare.
 *
 * If a single number is provided instead of an options object, that will be
 * used for both the width and height constraints on the image.
 *
 * This relies on Cloudflare image resizing. See:
 * https://developers.cloudflare.com/images/image-resizing
 */
function getOptimizedImageSource(source, options) {
    const optionsObject = typeof options === "number" ? { width: options, height: options } : options;
    if (typeof source === "string") {
        return getOptimizedImageUrl(source, optionsObject);
    }
    else if ((0, is_object_1.default)(source) && typeof source.uri === "string") {
        return Object.assign(Object.assign({}, source), { uri: getOptimizedImageUrl(source.uri, optionsObject) });
    }
    else {
        return source;
    }
}
